import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarTheme, useAppSelector } from '../../globalUtils/globalExports';
import { useScreenSize } from '../../globalUtils/globalHooks';
import { SidebarPropTypes } from '../AppLayout';
import SidebarItem from './SidebarItem';
import access from '../../auth/service/AccessControl';
// import localStorageInstance from '../../rmsReduxStore/api-service/LocalStorageService';
import { getGlobalReducer } from '../../rmsReduxStore/reduxExports';

const Sidebar: FC<SidebarPropTypes> = (props) => {
  const location = useLocation()

  const { expandSideBar, handleSidebarToggle } = props;
  const [selected, setSelected] = useState((access?.newDashboard?.view() && !access?.isSuperAdmin())? '/newDashboard':'/dashboard');
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const chargersRoutes = ['/manage-chargers', '/add-charger', '/charger-detail', '/charger', '/update-settings', '/add-parameter', '/view-parameter', '/edit-parameter', '/update-commands', '/view-command', '/add-command', '/edit-command', '/edit-spurious-charger', '/view-spurious-charger', 'spurious-chargers']
  const accessControlRoutes = ['/manage-users', '/roles', '/user', '/role', '/manage-org', '/org']
  const customerRoutes = ['/customers', '/customer', '/edit-history'];
  const chargingStationRoutes = ['/charging-stations', '/station']
  const reportsRoutes = ['/chargingHistory', '/chargerLogs', '/exceptionLogs','/sessionHistory','/uptimeReport', '/ac/uptime-report','/inventoryParameterReport','/configure-plc-logs'];
  const configureNotificationRoutes = ['/configureNotification', '/create-notification-rule'];
  const acConfigureNotificationRoutes = ['/ac/configure-notification', '/ac/create-notification-rule'];
  // const ruleEngineRoutes = ['/rule-engine', '/new-rule', '/define-execution-plan'];
  const updateCommandRoutes = ['/add-command', '/update-commands']
  const spuriousChargersRoutes = ['/edit-spurious-charger', '/view-spurious-charger', '/spurious-chargers']
  const acSpuriousChargersRoutes = ['/ac/spurious-chargers']
  const usbCertificatesRoutes = ['/edit-usb-certificate', '/add-usb-certificate', '/usb-certificates']
  const nocDashboard= ['/noc-dashboard'];
  const rmsSupportCentre = ['/help-and-faq-dashboard','/rms-support-center','/help-and-faq','/rms-support-center/chat','/troubleshooting','/documentation','/add-document']

  const softwareReleasesRoutes = ['/manage-software-version-releases','/add-version-release','/software-version-release-dashboard','/manage-deployment-logs']
  const advanceRuleEngineRoutes = ['/rule-engine-advance','/new-rule-advance','/define-execution-plan-advance']
  const {acAndDcToggleState} = useAppSelector(getGlobalReducer)

  const handleSelectedMenu = (value: string): void => {
    setSelected(value);
  };

  const handleOpenedMenu = (value: string | null): void => {
    setOpenMenu(value);
  };


  const screenSize = useScreenSize?.();
  const handleDrawerClose = useCallback(() => {
    handleSidebarToggle?.();
  }, [handleSidebarToggle]);


  // This useEffect runs on every path change and sets the selected side bar item 
  // and open's the side bar nested menu if any..
  useEffect(() => {
    const currentPathname = location.pathname
    if (currentPathname !== selected) {
      if (chargersRoutes.includes(currentPathname)) {
        handleOpenedMenu('Chargers');
        if (currentPathname === '/manage-chargers' || currentPathname === '/add-charger' || currentPathname === '/charger' || currentPathname === '/charger-detail') {
          setSelected('/manage-chargers')
        } else if (currentPathname === '/update-settings' || currentPathname === '/add-parameter' || currentPathname === '/view-parameter' || currentPathname === '/edit-parameter' || currentPathname === '/password-reset-logs') {
          setSelected('/update-settings')
        }
        else if (currentPathname === '/update-commands' || currentPathname === '/add-command' || currentPathname === '/view-command' || currentPathname === '/edit-command') {
          setSelected('/update-commands')
        }
        else if (currentPathname === '/spurious-chargers' || currentPathname === '/edit-spurious-charger' || currentPathname === '/view-spurious-charger') {
          setSelected('/spurious-chargers')
        }

      }
      else if (chargingStationRoutes.includes(currentPathname)) {
        setSelected('/charging-stations')
        handleOpenedMenu(null)
      }
      else if (customerRoutes.includes(currentPathname)) {
        setSelected('/customers')
        handleOpenedMenu(null)
      }
      else if (accessControlRoutes.includes(currentPathname)) {
        handleOpenedMenu('accessControl');
        if (currentPathname === '/manage-users' || currentPathname === '/user') {
          setSelected('/manage-users')
        } else if (currentPathname === '/roles' || currentPathname === '/role') {
          setSelected('/roles')
        } else if (currentPathname === '/manage-org' || currentPathname === '/org') {
          setSelected('/manage-org')
        }
      }
      else if (reportsRoutes.includes(currentPathname)) {
        handleOpenedMenu('reports');
        if(currentPathname === '/configure-plc-logs') setSelected('/sessionHistory')
        else setSelected(currentPathname)
      }
      else if (configureNotificationRoutes.includes(currentPathname)) {
        setSelected('/configureNotification')
        handleOpenedMenu(null)
      }
      else if (acConfigureNotificationRoutes.includes(currentPathname)) {
        setSelected('/ac/configure-notification')
        handleOpenedMenu(null)
      }
      else if (acSpuriousChargersRoutes.includes(currentPathname)) {
        setSelected('/ac/spurious-chargers')
        handleOpenedMenu('Chargers')
      }
      // else if (ruleEngineRoutes.includes(currentPathname)) {
      //   setSelected('/rule-engine')
      //   handleOpenedMenu(null)
      // }
      else if (updateCommandRoutes.includes(currentPathname)) {
        setSelected('/update-commands')
        handleOpenedMenu('Chargers')
      }
      else if (spuriousChargersRoutes.includes(currentPathname)) {
        setSelected('/spurious-chargers')
      }
      else if (usbCertificatesRoutes.includes(currentPathname)) {
        setSelected('/usb-certificates')
      }
      else if(softwareReleasesRoutes.includes(currentPathname)){
        handleOpenedMenu('softwareReleases')
        if(currentPathname === '/manage-software-version-releases' || currentPathname === '/software-version-release-dashboard' || currentPathname === '/manage-deployment-logs'){
           setSelected(currentPathname)
        }
        else if(currentPathname === '/add-version-release'){
          setSelected('/manage-software-version-releases')
        }
      }
      else if(nocDashboard.includes(currentPathname)){
        setSelected('/noc-dashboard')
      }
      else if(rmsSupportCentre.includes(currentPathname)) {
        handleOpenedMenu('aiSmartAssist')
        setSelected('/rms-support-center')
      }
      else if(advanceRuleEngineRoutes.includes(currentPathname)){
        handleOpenedMenu('advanceRuleEngine')
        setSelected('/rule-engine-advance')
      }
      else {
        handleOpenedMenu(null)
        setSelected(currentPathname)
      }
    }

  }, [location.pathname])
 
  // const allowedUsers= ['d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246','345acb60-b2e7-4e83-aa80-c2c70797c76f','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','84c5b1e7-28a7-4fb1-a869-a3f60ee95318', 'a5319a0b-7025-4934-bcac-ba451807d5b2',
  //   '7ac346c0-33fd-4fa7-be08-b8465b58e7a9','93b19d88-6799-48aa-ac27-02b4e4fb93f9', 'ca9678e2-52d0-4cf3-a2c8-4dd5727d7d35','e9b21cf0-cc25-4474-a279-04616a0d78f1','f1b61727-2cbf-4a95-9760-be993796489b','2877faa5-6226-45dd-b575-9ef680d87844','fb972809-0dc9-481f-ac7f-167dc7eb0c99',
  //   'aefdba75-9d7d-4e9d-aab9-86f2944aad46','e59b69f1-0fad-4093-bfa4-cad5a531f3e4'
  // ]
  // const rmsSupportCenterAccess = ['f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','de227ed8-9e35-4c45-a04d-5af10a6d850f','aefdba75-9d7d-4e9d-aab9-86f2944aad46','e9b21cf0-cc25-4474-a279-04616a0d78f1','93b19d88-6799-48aa-ac27-02b4e4fb93f9','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246']

 // const nocDashboardAccess = ['f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','de227ed8-9e35-4c45-a04d-5af10a6d850f','aefdba75-9d7d-4e9d-aab9-86f2944aad46','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246','e9b21cf0-cc25-4474-a279-04616a0d78f1','5a599f54-93ac-4160-b0e9-887d8827f058']

// const softwareReleaseAccess = ['aefdba75-9d7d-4e9d-aab9-86f2944aad46','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246','f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','e9b21cf0-cc25-4474-a279-04616a0d78f1']
  const sideBarFeatures = [
    {
      text: 'Dashboard',
      path: '/dashboard',
      className: 'dashboard__icon',
      isAccessible: access?.dashboard?.view() && (!access?.newDashboard?.view() || access?.isSuperAdmin())
    },
    {
      text: 'Dashboard',
      path: '/newDashboard',
      className: 'dashboard__icon',
      isAccessible: access?.newDashboard?.view()
    },
    {
      text: 'Alarms',
      path: '/alarms',
      className: 'alarm__management__icon',
      isAccessible: access?.alarms?.view()
    },
    {
      text: 'Chargers',
      path: '/manage-chargers',
      parentLabel: 'Chargers',
      className: 'chargers__icon',
      nestedMenus: [
        {
          text: 'Manage Chargers',
          path: '/manage-chargers',
          className: 'manage__chargers__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.chargers?.view()
        },
        {
          text: 'Update Settings',
          path: '/update-settings',
          className: 'set__parameters__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.updateSetting?.view()
        },
        {
          text: 'Update Commands',
          path: '/update-commands',
          className: 'set__parameters__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.updateSetting?.view()
        },
        {
          text: 'Spurious Chargers',
          path: '/spurious-chargers',
          className: 'set__parameters__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.spuriousCharger?.view()
        },
        {
          text: 'Password Reset Logs',
          path: '/password-reset-logs',
          className: 'set__parameters__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.updateSetting?.view()
        },
        // {
        //   text: 'Broadcast Message',
        //   path: '/broadcast-message',
        //   className: 'broadcast__message__icon',
        //   parentLabel: 'Chargers',
        // },
      ],
    },
    {
      text: 'Charging Stations',
      path: '/charging-stations',
      className: 'charging__stations__icon',
      isAccessible: access?.chargingStation?.view()
    },
    {
      text: 'Customers',
      path: '/customers',
      className: 'customer__management__icon',
      isAccessible: access?.customers?.view()
    },
    {
      text: 'Access Control',
      parentLabel: 'accessControl',
      path: '/manage-users',
      className: 'user__management__icon',
      nestedMenus: [
        {
          text: 'Organisations',
          path: '/manage-org',
          className: 'manage__org__icon',
          parentLabel: 'accessControl',
          isAccessible: access?.organisation?.view()
        },
        {
          text: 'Users',
          path: '/manage-users',
          className: 'manage__users__icon',
          parentLabel: 'accessControl',
          isAccessible: access?.users?.view()
        },
        {
          text: 'Roles',
          path: '/roles',
          className: 'role__management__icon',
          parentLabel: 'accessControl',
          isAccessible: access?.roles?.view()
        },
      ],
    },
    {
      text: 'Certificates',
      parentLabel: 'certificates',
      path: '/usb-certificates',
      className: 'certificate__dashboard__icon',
      nestedMenus: [
        {
          text: 'USB Certificates',
          path: '/usb-certificates',
          parentLabel: 'certificates',
          isAccessible: access?.ruleEngine?.view()
        },
        {
          text: 'Charger Certificates',
          path: '/charger-certificates',
          parentLabel: 'certificates',
          isAccessible: access?.ruleEngine?.view()
        },
      ],
    },
    // {
    //   text: 'USB Certificates',
    //   path: '/usb-certificates',
    //   className: 'customer__management__icon',
    //   isAccessible: access?.ruleEngine?.view()
    // },
    {
      text: 'Reports',
      parentLabel: 'reports',
      path: '/chargingHistory',
      className: 'reports__icon',
      nestedMenus: [
        {
          text: 'Charging History',
          path: '/chargingHistory',
          parentLabel: 'reports',
          isAccessible: access?.reports?.chargingHistory?.view()
        },
        {
          text: 'Session History',
          path:'/sessionHistory',
          parentLabel:'reports',
          isAccessible: access?.reports?.chargingHistory?.view()
        },
        {
          text: 'Charger Logs',
          path: '/chargerLogs',
          parentLabel: 'reports',
          isAccessible: access?.reports?.chargerLog?.status?.view() || access?.reports?.chargerLog?.setting?.view() || access?.reports?.chargerLog?.systemInfo?.view()
        },
        {
          text: 'Exception Logs',
          path: '/exceptionLogs',
          parentLabel: 'reports',
          isAccessible: access?.reports?.exceptionLogs?.view()
        },
        {
          text :'Uptime Report',
          path : '/uptimeReport',
          parentLabel:'reports',
          isAccessible: access?.reports?.uptimeReports?.view()
        },
        {
          text :'Inventory Report',
          path : '/inventoryParameterReport',
          parentLabel:'reports',
          isAccessible: access?.reports?.chargingHistory?.view()
        }
      ]
    },
    // {
    //   text: 'Rule Engine',
    //   parentLabel: 'ruleEngine',
    //   path: '/rule-engine',
    //   className: 'rule__engine__icon',
    //   isAccessible: access?.ruleEngine?.view()
    //   // nestedMenus : [
    //   //   {
    //   //     text: 'All Rules',
    //   //     path: '/rule-engine',
    //   //     parentLabel: 'ruleEngine',
    //   //     isAccessible : access?.reports?.chargingHistory?.view()
    //   //   },
    //   //   {
    //   //     text: 'Alarms',
    //   //     path: '/ruleEngineAlarms',
    //   //     parentLabel: 'ruleEngine',
    //   //     isAccessible :access?.reports?.chargerLog?.status?.view() || access?.reports?.chargerLog?.setting?.view() || access?.reports?.chargerLog?.systemInfo?.view()
    //   //   },
    //   //   {
    //   //     text: 'Anomaly',
    //   //     path: '/ruleEngineAnomaly',
    //   //     parentLabel: 'ruleEngine',
    //   //     isAccessible : access?.reports?.exceptionLogs?.view()
    //   //   },
    //   //   {
    //   //     text: 'Auto Alarms',
    //   //     path: '/ruleEngineAutoAlarms',
    //   //     parentLabel: 'ruleEngine',
    //   //     isAccessible : access?.reports?.exceptionLogs?.view()
    //   //   },
    //   // ]
    // },
    {
      text: 'Rule Engine',
      parentLabel: 'advanceRuleEngine',
      path: '/rule-engine-advance',
      className: 'rule__engine__icon',
      isAccessible: access?.advanceRuleEngineAccess?.view()
    },
    {
      text: 'Notifications',
      path: '/configureNotification',
      className: 'configure__notification__icon',
      isAccessible: access?.configureNotification?.view()
    },
    {
      text: 'Software Releases',
      parentLabel:'softwareReleases',
      path:'/software-version-release-dashboard',
      className:'software__release__icon',
      isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
      nestedMenus:[
        {
          text:'SW Dashboard',
          parentLabel:'softwareReleases',
          path:'/software-version-release-dashboard',
          isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
        },
        {
          text:'SW Version Releases',
          path:'/manage-software-version-releases',
          parentLabel:'softwareReleases',
          isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
        },
        {
          text:'Deployment Logs (History)',
          path:'/manage-deployment-logs',
          parentLabel:'softwareReleases',
          isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
        }
        
      ]
    },
    {
      text: 'NOC Dashboard',
      path: '/noc-dashboard',
      className: 'noc__dashboard__icon',
      isAccessible: access?.isSuperAdmin()
    },
    {
      text: 'AI Smart Assist',
      parentLabel: 'aiSmartAssist',
      path: '/rms-support-center',
      className:'rms__support__sidebar__icon',
      isAccessible: access?.aiSupportCenter?.aiSupportCenterChatBot?.view()
    }
  ];
  const acSideBarFeatures = [
    {
      text: 'Dashboard',
      path: '/ac/dashboard',
      className: 'dashboard__icon',
      isAccessible: access?.dashboard?.view()
    },
    {
      text: 'Chargers',
      path: '/ac/manage-chargers',
      parentLabel: 'Chargers',
      className: 'chargers__icon',
      nestedMenus: [
        {
          text: 'Manage Chargers',
          path: '/ac/manage-chargers',
          className: 'manage__chargers__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.chargers?.view()
        },
        {
          text: 'Update Settings',
          path: '/ac/update-settings',
          className: 'set__parameters__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.updateSetting?.view()
        },
        {
          text: 'Update Commands',
          path: '/ac/update-commands',
          className: 'set__parameters__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.updateSetting?.view()
        },
        {
          text: 'Spurious Chargers',
          path: '/ac/spurious-chargers',
          className: 'set__parameters__icon',
          parentLabel: 'Chargers',
          isAccessible: access?.spuriousCharger?.view()
        },
      ],
    },
        {
      text: 'Charging Stations',
      path: '/ac/charging-stations',
      className: 'charging__stations__icon',
      isAccessible: access?.chargingStation?.view()
    },
    {
      text: 'Alarms',
      path: '/ac/alarms',
      className: 'alarm__management__icon',
      isAccessible: access?.alarms?.view()
    },
    {
      text: 'Customers',
      path: '/ac/customers',
      className: 'customer__management__icon',
      isAccessible: access?.customers?.view()
    },
        {
      text: 'Access Control',
      parentLabel: 'accessControl',
      path: '/ac/manage-users',
      className: 'user__management__icon',
      nestedMenus: [
        {
          text: 'Organisations',
          path: '/ac/manage-org',
          className: 'manage__org__icon',
          parentLabel: 'accessControl',
          isAccessible: access?.organisation?.view()
        },
        {
          text: 'Users',
          path: '/ac/manage-users',
          className: 'manage__users__icon',
          parentLabel: 'accessControl',
          isAccessible: access?.users?.view()
        },
        {
          text: 'Roles',
          path: '/ac/roles',
          className: 'role__management__icon',
          parentLabel: 'accessControl',
          isAccessible: access?.roles?.view()
        },
      ],
    },
    {
      text: 'Certificate',
      path: '/ac/charger-certificates',
      className: 'certificate__dashboard__icon',
      isAccessible: true
    },
    {
      text: 'Reports',
      parentLabel: 'reports',
      path: '/ac/chargingHistory',
      className: 'reports__icon',
      nestedMenus: [
        {
          text: 'Charging History',
          path: '/ac/chargingHistory',
          parentLabel: 'reports',
          isAccessible: access?.reports?.chargingHistory?.view()
        },
        {
          text: 'Charger Logs',
          path: '/ac/chargerLogs',
          parentLabel: 'reports',
          isAccessible: access?.reports?.chargerLog?.status?.view() || access?.reports?.chargerLog?.setting?.view() || access?.reports?.chargerLog?.systemInfo?.view()
        },
        {
          text: 'Exception Logs',
          path: '/ac/exceptionLogs',
          parentLabel: 'reports',
          isAccessible: access?.reports?.exceptionLogs?.view()
        },
        {
          text :'Uptime Report',
          path : '/ac/uptime-report',
          parentLabel:'reports',
          isAccessible: true // access?.reports?.uptimeReports?.view()
        }
      ]
    },
    {
      text: 'Software Releases',
      parentLabel:'softwareReleases',
      path:'/ac/software-version-release-dashboard',
      className:'software__release__icon',
      isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
      nestedMenus:[
        {
          text:'SW Dashboard',
          parentLabel:'softwareReleases',
          path:'/ac/software-version-release-dashboard',
          isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
        },
        {
          text:'SW Version Releases',
          path:'/ac/manage-software-version-releases',
          parentLabel:'softwareReleases',
          isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
        },
        {
          text:'Deployment Logs (History)',
          path:'/ac/manage-deployment-logs',
          parentLabel:'softwareReleases',
          isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
        }
        
      ]
    },
    {
      text: 'Notifications',
      path: '/ac/configure-notification',
      className: 'configure__notification__icon',
      isAccessible: access?.configureNotification?.view()
    },
    {
      text: 'NOC Dashboard',
      path: '/ac/noc-dashboard',
      className: 'noc__dashboard__icon',
      isAccessible: access?.isSuperAdmin()
    }
  ];

  const filteredSideBarItems =acAndDcToggleState && acAndDcToggleState==='DC'? sideBarFeatures?.filter((item) => {
    if (item?.nestedMenus && item?.nestedMenus?.length > 0) {
      item.nestedMenus = item?.nestedMenus?.filter((nested) => nested?.isAccessible)
    }
    return item?.isAccessible || item?.nestedMenus?.length
  }) : acSideBarFeatures?.filter((item) => {
    if (item?.nestedMenus && item?.nestedMenus?.length > 0) {
      item.nestedMenus = item?.nestedMenus?.filter((nested) => nested?.isAccessible)
    }
    return item?.isAccessible || item?.nestedMenus?.length
  })

  const drawer = (
    <List component="nav" style={{ borderRight: '0px', padding: 0 }}>
      {filteredSideBarItems?.map((feature, index) => (
        <SidebarItem
          toggleOpen={openMenu}
          handleOpenedMenu={handleOpenedMenu}
          selected={selected}
          handleSelect={handleSelectedMenu}
          handleDrawerClose={handleDrawerClose}
          {...feature}
          key={index}
        />
      ))}
    </List>
  );

  return (
    <ThemeProvider theme={SidebarTheme}>
      <Drawer
        variant="permanent"
        className="app__sidebar"
        ModalProps={{
          keepMounted: true,
        }}
        open={expandSideBar}
        onClose={handleDrawerClose}
        sx={{
          display: screenSize?.width <= 800 && !expandSideBar ? 'none' : 'block',
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: 230,
            borderRight: 0,
            boxShadow:
              '0px 6px 4px -2px rgba(0,0,0,0.005), 0px 8px 6px 3px rgba(0,0,0,0.04), 0px 1px 5px 0px rgba(0,0,0,0.05)',
          },
        }}
      >
        {drawer}
        <div className='app__version'>

          {localStorage?.getItem('spin-rms-app-version') !== null &&
            moment(new Date(localStorage?.getItem('spin-rms-app-version') as string)).format('lll')}</div>
      </Drawer>
    </ThemeProvider>
  );
};

export default Sidebar;
